import {O} from "web-vcore";

export class PestState {
	@O accessor autoShutOff_atTime = -1;
}